var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.caption)?_c('span',{staticClass:"caption",domProps:{"innerHTML":_vm._s(_vm.setCaption())}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }